import { Observable } from 'rxjs';
import { ContactUsRequest } from '../../models/website/contactus/contactUsRequest';
import { GenericService } from './../generic.service';
import { Injectable } from '@angular/core';
import { ContactUsResponse } from '../../models/website/contactus/contactUsResponse';
import { ContactUsListRequest } from '../../models/website/contactus/contactUsListRequest';
import { apiResponse } from '../../models/apiResponse';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private genericService: GenericService) {

   }

   submitContactUsForm(contactUsRequest:ContactUsRequest):Observable<ContactUsResponse>{
    return this.genericService.post('contactus',contactUsRequest);
   }

   getContactUsList(request: ContactUsListRequest): Observable<apiResponse<ContactUsResponse[]>> {
    return this.genericService.post('contactus/list', request);
   }

  downloadContactUsList(request: ContactUsListRequest): Observable<HttpResponse<ArrayBuffer>> {
  return this.genericService.getBinaryPost('download/contactus/list', request);  // removed 'superadmin/'
}
}
